var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 7.66656L5.83333 8.9999L8.83333 5.99988M11.8333 7.9999C11.8333 11.2722 8.264 13.6522 6.96533 14.4098C6.81773 14.4959 6.74393 14.539 6.6398 14.5613C6.55893 14.5786 6.44106 14.5786 6.3602 14.5613C6.25606 14.539 6.18226 14.4959 6.03466 14.4098C4.73597 13.6522 1.16666 11.2722 1.16666 7.9999V4.81161C1.16666 4.2786 1.16666 4.0121 1.25384 3.78301C1.33084 3.58064 1.45598 3.40006 1.61844 3.25689C1.80233 3.09483 2.05186 3.00126 2.55093 2.81411L6.12546 1.47366C6.26406 1.42168 6.33333 1.3957 6.40466 1.3854C6.46786 1.37626 6.53213 1.37626 6.59533 1.3854C6.66666 1.3957 6.73593 1.42168 6.87453 1.47366L10.4491 2.81411C10.9481 3.00126 11.1977 3.09483 11.3815 3.25689C11.544 3.40006 11.6691 3.58064 11.7461 3.78301C11.8333 4.0121 11.8333 4.2786 11.8333 4.81161V7.9999Z",
    stroke: "#4B4B4B",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.c52ba56cdfbc3cb9967f4b932457b285.svg";
export { ForwardRef as ReactComponent };